import React from "react";
import { Button, Modal, Table, Space } from "antd";
import { ColumnType } from "antd/lib/table";
import { EvaluationViewpointDetail } from "./ScoringPage";

interface Props {
  visible: boolean;
  width?: number;
  viewPoints: EvaluationViewpointDetail[];
  onDataSelect?: (record?: EvaluationViewpointDetail) => void;
  onCancel?: () => void;
}

export const EvaluationViewpointSelecter = ({
  visible = false,
  width = 600,
  viewPoints,
  onDataSelect,
  onCancel,
}: Props) => {
  const [isVisible, setIsVisible] = React.useState(visible);
  const [selectedRecord, setSelectedRecord] =
    React.useState<EvaluationViewpointDetail>();

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    setIsVisible(visible);
  }, [visible]);
  const columns: ColumnType<EvaluationViewpointDetail>[] = [
    {
      title: "評価値",
      width: "60px",
      dataIndex: "highScore",
      key: "highScore",
    },
    {
      title: "評価基準",
      dataIndex: "evaluationCriteria",
      key: "evaluationCriteria",
    },
    {
      title: "評価例",
      dataIndex: "evaluationExample",
      key: "evaluationExample",
    },
  ];

  const onDataChange = () => {
    if (selectedRecord) {
      onDataSelect?.(selectedRecord);
      // setIsVisible(false);
    }
  };

  return (
    <Modal
      maskClosable={false}
      centered
      visible={isVisible}
      // onOk={() => setVisible(false)}
      onCancel={onCancel}
      width={width}
      footer={null}
    >
      <Space direction="vertical">
        <Button onClick={onDataChange} type="primary">
          評価値選択
        </Button>
        <Table
          bordered
          size={"small"}
          rowSelection={{
            type: "radio",
            onSelect: (record, selected, selectedRows, nativeEvent) => {
              setSelectedRecord(record);
            },
          }}
          rowKey={(record) => record.evaluationViewpointDetailId}
          columns={columns}
          dataSource={viewPoints}
          scroll={{ y: 720 }}
          pagination={false}
        />
      </Space>
    </Modal>
  );
};
